import AdminRequestedVaspsTable from './AdminRequestedVaspsTable'

export default AdminRequestedVaspsTable
